var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAlertTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.39043 18.0986L10.6153 3.89195C11.0699 3.10679 11.2972 2.71421 11.5937 2.58235C11.8524 2.46734 12.1476 2.46734 12.4063 2.58235C12.7028 2.71421 12.9301 3.10679 13.3847 3.89195L21.6096 18.0986C22.0658 18.8866 22.2939 19.2806 22.2602 19.6039C22.2308 19.886 22.083 20.1423 21.8536 20.309C21.5907 20.5002 21.1354 20.5002 20.2249 20.5002H3.77511C2.86459 20.5002 2.40933 20.5002 2.14637 20.309C1.91701 20.1423 1.76924 19.886 1.73984 19.6039C1.70612 19.2806 1.93423 18.8866 2.39043 18.0986Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9V13M12 17H12.01",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlertTriangle);
export default __webpack_public_path__ + "static/media/IconAlertTriangle.22d4603befe8f685cc4669e2fe8f120a.svg";
export { ForwardRef as ReactComponent };